import { useHubspotForm } from "next-hubspot";
import { Box, Spinner, Text } from "@chakra-ui/react";

const HubspotContactForm = () => {
  const { isFormCreated, error } = useHubspotForm({
    portalId: "43951417",
    formId: "c98b7951-35e0-456a-a1bc-5c2e4e73042e",
    region: "na1",
    target: "#hubspotForm",
  });

  if (error) {
    return <Text>Error</Text>;
  }

  return (
    <Box
      boxShadow={"lg"}
      borderRadius={"8px"}
      px={{ base: 4, sm: 8 }}
      py={{ base: 4, sm: 8, md: 12 }}
      w={"full"}
      minH={"540px"}
    >
      {!isFormCreated && <Spinner />}
      {isFormCreated && <Box id="hubspotForm"></Box>}
    </Box>
  );
};

export default HubspotContactForm;
